import { Button } from '@repo/ui/components/ui/button'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Providers } from '@/lib/providers'
import { SentryErrorBoundary, SentryProvider } from './lib/sentry'
import { routeTree } from './routeTree.gen'
import './styles.css'

const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Providers>
      <SentryErrorBoundary
        fallback={({ error }: { error: unknown }) => {
          const message = error instanceof Error ? error.message : 'Unknown error'
          return (
            <div className="flex min-h-screen items-center justify-center bg-background">
              <div className="app-premium-panel max-w-md rounded-[6px] p-6 text-center">
                <h1 className="mb-4 text-2xl font-bold text-destructive">Execution interrupted</h1>
                <p className="mb-4 text-muted-foreground">
                  The issue was captured. Reload to restore your workspace session.
                </p>
                <details className="text-left text-sm">
                  <summary className="mb-2 cursor-pointer font-medium">Error details</summary>
                  <pre className="mt-2 overflow-auto rounded-[4px] bg-muted p-4">{message}</pre>
                </details>
                <Button type="button" onClick={() => window.location.reload()} className="mt-6">
                  Reload workspace
                </Button>
              </div>
            </div>
          )
        }}
      >
        <SentryProvider>
          <RouterProvider router={router} />
        </SentryProvider>
      </SentryErrorBoundary>
    </Providers>
  </StrictMode>
)
